import React from 'react';
import { Award, Users, Calendar, MapPin } from 'lucide-react';
import { events } from '../../../../data/events';

const TRCSLSection = () => {
  // Get the TRCSL event data
  const trcslEvent = events.eventSeries?.events?.find(event => event.title.includes('TRCSL'));

  if (!trcslEvent) return null;

  return (
    <div className="w-full max-w-[1920px] px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24 py-12 bg-Color-White">
      {/* Section Title */}
      <div className="mb-8">
        <h2 className="text-3xl sm:text-4xl font-bold text-Color-Black font-['Montserrat'] flex items-center gap-3">
          <Award className="w-8 h-8 text-Color-Brand-Green" />
          TRCSL ICT Volunteer Boot Camp 2025
        </h2>
        <div className="h-1 w-32 bg-Color-Brand-Green rounded-full mt-3"></div>
      </div>

      {/* Main Content Container */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
        {/* Left Content - Image */}
        <div className="flex flex-col justify-center order-2 lg:order-1">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src={trcslEvent.image} 
              alt={trcslEvent.title}
              className="w-full h-[400px] lg:h-[500px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-Color-Black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="flex items-center gap-2 text-Color-White mb-2">
                <MapPin className="w-5 h-5" />
                <span className="font-['Montserrat'] font-semibold">Faculty of Engineering, University of Ruhuna</span>
              </div>
              <div className="flex items-center gap-2 text-Color-White">
                <Calendar className="w-5 h-5" />
                <span className="font-['Montserrat']">August 11-22, 2025 (Boot Camp) | Sept-Oct 2025 (Workshops)</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Content - Description */}
        <div className="flex flex-col justify-center space-y-6 order-1 lg:order-2">
          <div className="border-l-4 border-Color-Brand-Green pl-6">
            <h3 className="text-2xl sm:text-3xl font-semibold text-Color-Black font-['Montserrat'] mb-4">
              Silver Jubilee ICT Volunteer Program
            </h3>
            <p className="text-base sm:text-lg text-Color-Black font-['Montserrat'] leading-relaxed mb-4">
              {trcslEvent.brief}
            </p>
          </div>

          {/* Key Highlights */}
          <div className="bg-Color-Foreground/20 rounded-xl p-6 border-l-4 border-Color-Brand-Green">
            <h4 className="text-xl font-semibold text-Color-Black font-['Montserrat'] mb-4">
              Program Highlights
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">Two-week residential boot camp training</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">50 undergraduate volunteers trained</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">ICT workshops in rural schools</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">Real-world teaching and leadership experience</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-Color-Brand-Green text-xl font-bold">•</span>
                <span className="text-Color-Black font-['Montserrat']">Collaboration with TRCSL</span>
              </li>
            </ul>
          </div>

          {/* Additional Info Badge */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-Color-Brand-Green/10 border border-Color-Brand-Green/20 px-6 py-3 rounded-full">
              <Users className="w-5 h-5 text-Color-Brand-Green" />
              <span className="text-Color-Brand-Green font-semibold font-['Montserrat']">
                Bridging the Digital Divide
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TRCSLSection;
